import Phaser from 'phaser';
import { getTextStyle } from '../scripts/FontConfig.js';


export default class StartScene extends Phaser.Scene {
  constructor() {
    super('StartScene');
  }
  // Define asset paths as constants for maintainability

  preload() {
  }
  
  create() {
    const width = this.cameras.main.width;
    const height = this.cameras.main.height;
    
    // Background
    // Background image
    this.add.image(width / 2, height / 2, 'startScreen').setOrigin(0.5);

    
    // Check game state to determine start button label
    const gameState = this.getGameState();
    
    // Create menu buttons
    this.createMenuButtons(gameState);
  }
  
  getGameState() {
    // Check if there's an ongoing game by looking for saved progress
    const rescuedFriends = localStorage.getItem('hypnobreaker_rescued_friends');
    const lastPlayerPos = window.hypnoBreakerData?.lastPlayerPos;
    
    const hasRescuedFriends = rescuedFriends && JSON.parse(rescuedFriends).length > 0;
    const hasPlayerProgress = lastPlayerPos && (lastPlayerPos.x !== undefined || lastPlayerPos.y !== undefined);
    
    if (hasRescuedFriends || hasPlayerProgress) {
      return 'ongoing'; // Game in progress
    }
    return 'new'; // No game started
  }
  
  createMenuButtons(gameState) {
    const width = this.cameras.main.width;
    const height = this.cameras.main.height;
    
    // Determine start button text based on game state
    let startButtonText = 'Starten';
    if (gameState === 'ongoing') {
      startButtonText = 'Hervatten';
    }
    
    // Start/Resume/Restart Button
    const startButtonBg = this.add.rectangle(212, height / 2 + 4, 222, 48, 0x3498db, 0.8);
    startButtonBg.setStrokeStyle(2, 0x2980b9);
    
    const startButton = this.add.text(212, height / 2 + 4, startButtonText, getTextStyle({
      fontSize: '32px',
      fill: '#ffffff',
      fontWeight: 'bold'
    })).setOrigin(0.5);
    
    // Make both background and text interactive
    startButtonBg.setInteractive({ useHandCursor: true });
    startButton.setInteractive({ useHandCursor: true });
    
    const startButtonHover = () => {
      startButtonBg.setFillStyle(0x5dade2, 0.9);
      startButtonBg.setStrokeStyle(2, 0x3498db);
    };
    
    const startButtonOut = () => {
      startButtonBg.setFillStyle(0x3498db, 0.8);
      startButtonBg.setStrokeStyle(2, 0x2980b9);
    };
    
    const startButtonClick = () => {
      if (gameState === 'ongoing') {
        // Resume existing game - go through intro with resume flag
        this.scene.start('IntroScene', { isResume: true });
      } else {
        // Start new game - reset everything except sessionId, then show intro
        this.startNewGame();
      }
    };
    
    startButtonBg.on('pointerover', startButtonHover);
    startButtonBg.on('pointerout', startButtonOut);
    startButtonBg.on('pointerdown', startButtonClick);
    startButton.on('pointerover', startButtonHover);
    startButton.on('pointerout', startButtonOut);
    startButton.on('pointerdown', startButtonClick);
    
    // Add restart option if there's an ongoing game
    if (gameState === 'ongoing') {
      const restartButtonBg = this.add.rectangle(212, height / 2 + 58, 222, 48, 0xe74c3c, 0.8);
      restartButtonBg.setStrokeStyle(2, 0xc0392b);
      
      const restartButton = this.add.text(212, height / 2 + 58, 'Opnieuw beginnen', getTextStyle({
        fontSize: '24px',
        fill: '#ffffff',
        fontWeight: 'normal'
      })).setOrigin(0.5);
      
      restartButtonBg.setInteractive({ useHandCursor: true });
      restartButton.setInteractive({ useHandCursor: true });
      
      const restartButtonHover = () => {
        restartButtonBg.setFillStyle(0xec7063, 0.9);
        restartButtonBg.setStrokeStyle(2, 0xe74c3c);
      };
      
      const restartButtonOut = () => {
        restartButtonBg.setFillStyle(0xe74c3c, 0.8);
        restartButtonBg.setStrokeStyle(2, 0xc0392b);
      };
      
      const restartButtonClick = () => {
        this.startNewGame();
      };
      
      restartButtonBg.on('pointerover', restartButtonHover);
      restartButtonBg.on('pointerout', restartButtonOut);
      restartButtonBg.on('pointerdown', restartButtonClick);
      restartButton.on('pointerover', restartButtonHover);
      restartButton.on('pointerout', restartButtonOut);
      restartButton.on('pointerdown', restartButtonClick);
    }
    
    // Help Button
    const helpButtonY = gameState === 'ongoing' ? height / 2 + 112 : height / 2 + 58;
    const helpButtonBg = this.add.rectangle(212, helpButtonY, 222, 48, 0xf39c12, 0.8);
    helpButtonBg.setStrokeStyle(2, 0xe67e22);
    
    const helpButton = this.add.text(212, helpButtonY, 'Help', getTextStyle({
      fontSize: '24px',
      fill: '#ffffff',
      fontWeight: 'normal'
    })).setOrigin(0.5);
    
    helpButtonBg.setInteractive({ useHandCursor: true });
    helpButton.setInteractive({ useHandCursor: true });
    
    const helpButtonHover = () => {
      helpButtonBg.setFillStyle(0xf7dc6f, 0.9);
      helpButtonBg.setStrokeStyle(2, 0xf39c12);
    };
    
    const helpButtonOut = () => {
      helpButtonBg.setFillStyle(0xf39c12, 0.8);
      helpButtonBg.setStrokeStyle(2, 0xe67e22);
    };
    
    const helpButtonClick = () => {
      this.scene.start('IntroScene', { isHelp: true });
    };
    
    helpButtonBg.on('pointerover', helpButtonHover);
    helpButtonBg.on('pointerout', helpButtonOut);
    helpButtonBg.on('pointerdown', helpButtonClick);
    helpButton.on('pointerover', helpButtonHover);
    helpButton.on('pointerout', helpButtonOut);
    helpButton.on('pointerdown', helpButtonClick);
    
    // Credits Button
    const creditsButtonY = gameState === 'ongoing' ? height / 2 + 166 : height / 2 + 112;
    const creditsButtonBg = this.add.rectangle(212, creditsButtonY, 222, 48, 0x9b59b6, 0.8);
    creditsButtonBg.setStrokeStyle(2, 0x8e44ad);
    
    const creditsButton = this.add.text(212, creditsButtonY, 'Over deze game', getTextStyle({
      fontSize: '24px',
      fill: '#ffffff',
      fontWeight: 'normal'
    })).setOrigin(0.5);
    
    creditsButtonBg.setInteractive({ useHandCursor: true });
    creditsButton.setInteractive({ useHandCursor: true });
    
    const creditsButtonHover = () => {
      creditsButtonBg.setFillStyle(0xbb8fce, 0.9);
      creditsButtonBg.setStrokeStyle(2, 0x9b59b6);
    };
    
    const creditsButtonOut = () => {
      creditsButtonBg.setFillStyle(0x9b59b6, 0.8);
      creditsButtonBg.setStrokeStyle(2, 0x8e44ad);
    };
    
    const creditsButtonClick = () => {
      this.scene.start('CreditsScene');
    };
    
    creditsButtonBg.on('pointerover', creditsButtonHover);
    creditsButtonBg.on('pointerout', creditsButtonOut);
    creditsButtonBg.on('pointerdown', creditsButtonClick);
    creditsButton.on('pointerover', creditsButtonHover);
    creditsButton.on('pointerout', creditsButtonOut);
    creditsButton.on('pointerdown', creditsButtonClick);
  }
  
  startNewGame() {
    // Reset game data but preserve sessionId
    const sessionId = window.sessionId;
    const sessionStart = window.sessionStart;
    
    // Clear game progress
    localStorage.removeItem('hypnobreaker_rescued_friends');
    if (window.hypnoBreakerData) {
      delete window.hypnoBreakerData.lastPlayerPos;
    }
    
    // Restore session data
    if (sessionId) {
      window.sessionId = sessionId;
      localStorage.setItem('sessionId', sessionId);
    }
    if (sessionStart) {
      window.sessionStart = sessionStart;
      localStorage.setItem('sessionStart', sessionStart);
    }
    
    // Start the game through IntroScene
    this.scene.start('IntroScene', { isResume: false });
  }
}
